import { render, staticRenderFns } from "./PriceCodeEditPriceDialog.vue?vue&type=template&id=bb817e82&scoped=true"
import script from "./PriceCodeEditPriceDialog.vue?vue&type=script&lang=js"
export * from "./PriceCodeEditPriceDialog.vue?vue&type=script&lang=js"
import style1 from "./PriceCodeEditPriceDialog.vue?vue&type=style&index=1&id=bb817e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb817e82",
  null
  
)

export default component.exports